const TwoColumnsHorizontalCard = ({items,...props}) => {
    return (
        <div className={`two-columns-horizontal-card tw-grid ${items.length == 1 ? 'lg:tw-grid-cols-4' : 'lg:tw-grid-cols-2'} tw-gap-10`}>
            {items.map((item, index) => (<div key={index} 
                className={`tw-grid-cols-2 tw-gap-10
                    ${item.fields.rmBg != "true" ? 'tw-bg-grey-medium' : ''} 
                    ${items.length == 1 ? 'lg:tw-col-span-2 lg:tw-col-start-2' : ''}
                    ${item.fields.displayImageAsIcon == "true" ? "tw-flex tw-gap-5" : "tw-grid"}
                    ${item.fields.rmSpacing != "true" ? "tw-p-10" : ""}
                `}>
                {!!item.fields.image && <div className={`${item.fields.displayImageAsIcon == "true" ? "tw-w-8 tw-h-8" : ""} tw-col-span-1`}>
                    <img src={item.fields.image.url} alt={item.fields.image.label} />
                </div>}
                <div className={`${item.fields.displayImageAsIcon == "true" ? "tw-flex-1" : "tw-flex tw-flex-col tw-justify-center"} richtext ${!!item.fields.image ? "tw-col-span-1" : "tw-col-span-2"} tw-text-sm`} dangerouslySetInnerHTML={{ __html: item.fields.content }} />
            </div>))}
        </div>
    );
};

export default TwoColumnsHorizontalCard;